import { render, staticRenderFns } from "./AlertMessageSuccess.vue?vue&type=template&id=fa8f6c52&"
import script from "./AlertMessageSuccess.vue?vue&type=script&lang=js&"
export * from "./AlertMessageSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports